"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.AccountMenu = exports.orgIdToHrefFor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _CommonChrome = _interopRequireDefault(require("../CommonChrome"));

var _AccountDropdown = _interopRequireDefault(require("../CommonChrome/components/AccountDropdown"));

var _UserContext = require("../CommonChrome/components/UserContext");

var _typeDefs = require("../../graphql/__generated__/typeDefs");

var _Icon = _interopRequireDefault(require("../../components/Icon"));

var _ActivationPages = require("./links/ActivationPages");

var _getDomains = require("./links/getDomains");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var defaultLabels = {
  organizations: 'My Organizations',
  settings: 'My Settings',
  profile: 'Profile',
  logout: 'Log out'
};

var addOrgIdParam = function addOrgIdParam(url, id) {
  var parsedUrl = (0, _urlParse["default"])(url, true);
  return parsedUrl.set('query', _objectSpread(_objectSpread({}, parsedUrl.query), {}, {
    swicus_org_id: id
  })).toString();
};
/**
 * Accepts a function that should return the current URL with any needed
 * transformations (e.g. removing non-SWICUS org ID from the path, moving
 * up to a list page if on a specific APM service or AO dashboard, etc.).
 * Returns a function that replaces the current SWICUS org ID in the url
 * with the new one if present, otherwise just adds the swicus_org_id param.
 */


var orgIdToHrefFor = function orgIdToHrefFor(getCurrentUrl) {
  return function (id, currentSwicusOrgId) {
    var currentUrl = getCurrentUrl(currentSwicusOrgId);

    if (currentSwicusOrgId && currentUrl.match(currentSwicusOrgId)) {
      return currentUrl.replace(currentSwicusOrgId, id);
    }

    return addOrgIdParam(currentUrl, id);
  };
};

exports.orgIdToHrefFor = orgIdToHrefFor;
var orgIdToHrefDefault = orgIdToHrefFor(function () {
  return window.location.href;
});
/**
 *
 * @property {Product} currentProduct - current product. Links for organizations
 * without access to the current product will point to the home page.
 * @property {AccountMenuLabels} labels - Optional custom labels to use in place
 * of 'My Organizations', 'My Settings', 'My Profile', and 'Logout', e.g.
 * if the consumer has translations set up via i18next.
 * @property {(id: string, currentSwicusOrgId: string) => string} orgIdToHref -
 * an optional function that will accept the desired org id and the current org id
 * and return a url to use for that link in the list of organizations. Most use
 * cases will hopefully be fine with the default, which simply replaces the
 * current SWICUS org ID in the url with the new one if present, otherwise just
 * adds the swicus_org_id param. More complex use cases can use the
 * `orgIdToHrefFor` helper to apply any needed transformations (e.g. removing
 * non-SWICUS org ID from the path, moving up to a list page if on a specific
 * APM service or AO dashboard, etc.) before adding the new swicus org id.
 *
 * --
 *
 * Current properties that I hope to refactor to automatically inherit from the
 * `Navigation` ancestor via context:
 * @property {boolean} inverted - dark theme
 * @property {string} environment - staging/production/development. Controls
 * the domain used for the profile link.
 * @property {DomainOverrides} domains - optionally override the `common` domain
 * that will be used by the `Profile` link instead of using the automatic one
 * based on the `environment` prop.
 */

var AccountMenu = function AccountMenu(_ref) {
  var environment = _ref.environment,
      _ref$domains = _ref.domains,
      domains = _ref$domains === void 0 ? {} : _ref$domains,
      currentProduct = _ref.currentProduct,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? defaultLabels : _ref$labels,
      inverted = _ref.inverted,
      _ref$orgIdToHref = _ref.orgIdToHref,
      orgIdToHref = _ref$orgIdToHref === void 0 ? orgIdToHrefDefault : _ref$orgIdToHref;
  var finalDomains = (0, _getDomains.getDomains)(environment, domains);

  var _useUserContext = (0, _UserContext.useUserContext)(),
      loading = _useUserContext.loading,
      user = _useUserContext.user,
      currentOrganization = _useUserContext.currentOrganization,
      _useUserContext$organ = _useUserContext.organizations,
      organizations = _useUserContext$organ === void 0 ? [] : _useUserContext$organ;

  var activeKey = (0, React.useContext)(_CommonChrome["default"].Context).activeKey;

  if (loading) {
    return null;
  }

  if (!currentOrganization || !user) {
    // If we weren't able to properly load the full context, at least
    // show a fallback with a logout link
    return /*#__PURE__*/React.createElement(_AccountDropdown["default"], {
      email: "",
      userName: user ? getUserName(user) : '',
      organization: currentOrganization || {
        name: ' '
      },
      inverted: inverted,
      unifiedError: true
    }, /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuItem, {
      href: "".concat(finalDomains.common, "/common/logout")
    }, labels.logout));
  }

  return /*#__PURE__*/React.createElement(_AccountDropdown["default"], {
    email: user.email,
    userName: getUserName(user),
    organization: currentOrganization,
    inverted: inverted,
    unified: true
  }, /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuHeading, null, labels.organizations), organizations.map(function (organization) {
    var href = !currentProduct || orgHasProductAccess(organization, currentProduct) ? orgIdToHref(organization.id, currentOrganization.id) : (0, _ActivationPages.getActivationPage)(activeKey || '', {
      product: currentProduct,
      domains: finalDomains,
      orgId: organization.id
    });
    return /*#__PURE__*/React.createElement(_CommonChrome["default"].AccountMenuItem, {
      key: organization.id,
      organization: organization,
      isActive: organization.id === currentOrganization.id,
      href: href,
      "data-qa": "nav-switch-to-org-".concat(organization.id)
    });
  }), /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuDivider, null), /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuHeading, null, labels.settings), /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuItem, {
    href: "".concat(finalDomains.common, "/settings/profile?swicus_org_id=").concat(currentOrganization.id),
    newTab: true
  }, labels.profile, /*#__PURE__*/React.createElement(_Icon["default"], {
    name: "external-link-small"
  })), /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuDivider, null), /*#__PURE__*/React.createElement(_CommonChrome["default"].NavMenuItem, {
    href: "".concat(finalDomains.common, "/common/logout")
  }, labels.logout));
};

exports.AccountMenu = AccountMenu;
var _default = AccountMenu;
exports["default"] = _default;

function getUserName(user) {
  var firstName = (user === null || user === void 0 ? void 0 : user.firstName) || '';
  var lastName = (user === null || user === void 0 ? void 0 : user.lastName) || '';
  return "".concat(firstName, " ").concat(lastName).trim();
}

function orgHasProductAccess(organization, currentProduct) {
  if (!currentProduct) return true;
  return organization.products.some(function (product) {
    return product.activated && product.name === currentProduct && product.productRole !== _typeDefs.ProductRole.NoAccess;
  });
}